export const NOTIFICATION_MESSAGES = Object.freeze({
    PRODUCT_REVIEW: [
        'Step 1 of 5. Choose one of your orders',
        'Step 2 of 5. Click on the item you would like to review',
        'Step 3 of 5. Click on the Reviews tab',
        'Step 4 of 5. Сlick on Write a review button',
        'Step 5 of 5. Submit your review'
    ]
});
